<template>
  <div class="polar">
      <div class="polar-main">
        <div class="polar-header">
            <h3 class="polar-title">极地探险</h3>
            <div class="line-bold"></div>
        </div>
        <div class="polar-sub-title">
            勇敢、坚持、强者的游戏
        </div>
        <div class="polar-refresh">
            <div class="polar-refresh-name" @click='gotoallrouter'>去看看</div>
            <div class="polar-refresh-img"></div>
        </div>
        <div class="ploar-main">
            <div class="ploar-footer-list" v-for="(item, index) in lists" :key="index" @click='gotodetail(item)'>
                <img :src="item.thumbnail" alt="">
                <div class="small-pop"></div>
                <div class="ploar-list-tag">
                    <p v-for="(tagItem, tagIndex) in item.topTags" :key="tagIndex">{{tagItem}}</p>
                </div>
                <div class="ploar-trangle">
                    <img :src="RightBigIcon" alt="">
                </div>
                <div class="ploar-footer-main">
                    <p class="ploar-footer-main-title">
                        {{item.title}}
                    </p>
                    <div class="ploar-footer-main-time">
                        <svg-icon icon-class="time2"></svg-icon>
                        旅行时间:{{item.time}}
                    </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import PolarImg from '@/assets/img/polar-img.png'
import TimeIcon from '@/assets/img/time-icon.png'
import RightBigIcon from '@/assets/img/right-big-icon.png'
import {getthemelist} from '@/api/theme.js'
import {sliceDate} from '@/utils/index'
import {querycontent} from '@/api/content.js'
export default {
  name: 'Polar',
  data () {
    return {
      TimeIcon,
      RightBigIcon,
      querylist: {
        page: 1,
        limit: 3,
        menuId: 1,
        sort: 'order_no',
        order: 'asc'
      },
      lists: [
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: PolarImg,
          active: true
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: PolarImg,
          active: false
        },
        {
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: PolarImg,
          active: false
        }
      ],
      themes: []
    }
  },
  methods: {
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.getlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    getlist () {
      querycontent(this.querylist).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          items[i].classes = this.themes[items[i].themeId]
          items[i].active = false
        }
        items[0].active = true
        this.lists = items
      })
    },
    gotoallrouter () {
      this.$router.push({path: '/allRouterLists'})
    },
    gotodetail (item) {
      this.$router.push({
        path: '/routeDetail',
        query: {
          id: item.id,
          img: item.thumbnail
        }
      })
    }
  },
  created () {
    this.getthemelist()
  }
}
</script>

<style lang="scss" scoped>
.polar {
    width: 100%;
    // height: 674px;
    padding-bottom: 60px;
    margin-top: 58px;
    background: url('../../assets/img/polar-bg.png') no-repeat center;
    background-size: cover;
    overflow: hidden;
}
.polar-main {
    width: 1232px;
    height: 100%;
    margin: 0 auto;
    .polar-header {
        width: 780px;
        border-bottom: 1px solid #6dc6ff;
        margin: 0 auto;
        position: relative;
    }
    .polar-title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 34px;
        color: #fff;
        line-height: 1;
        margin-top: 60px;
        margin-bottom: 8px;
    }
    .line-bold {
        width: 44px;
        height: 3px;
        position: absolute;
        left: 50%;
        bottom: -2px;
        margin-left: -22px;
        background: #fff;
    }
    .polar-sub-title {
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 16px;
        margin-top: 10px;
    }
    .polar-refresh {
        width: 1232px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0 auto;
        cursor: pointer;
        &:hover {
            .polar-refresh-name {
                color: #fff;
            }
            .polar-refresh-img {
                background: url(../../assets/img/right-icon-w.png);
            }
        }
    }
    .polar-refresh-name {
        font-size: 14px;
        color: #a0d7f9;
        font-weight: bold;
    }
    .polar-refresh-img {
        width: 10px;
        height: 9px;
        margin-left: 6px;
        background: url(../../assets/img/right-icon.png);
    }
    .ploar-main {
        width: 100%;
        margin: 10px auto 0;
        display: flex;
        justify-content: space-between;
    }
    .ploar-footer-list {
        width: 395px;
        height: 267px;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        .small-pop{
          width:100%;
          height:100%;
          background: rgba(0,0,0,0.4);
          // opacity: 40%;
          position:absolute;
          left: 0;
          top: 0;
        }
        img {
            width: 395px;
            height: 267px;
            transform: scale(1);
            transition: transform 0.5s;
        }
        &:hover {
            box-shadow: 0px 0px 5px rgb(59, 59, 59);
            transition: all 0.2s;
            img {
                transform: scale(1.02);
                transition: all 0.5s;
            }
            .small-pop{
              transition: all 0.3s;
              background: rgba(0,0,0,0)
            }
            .ploar-list-tag{
              transition: all 0.3s;
              background: rgba(0,0,0,0.7)
            }
            .ploar-footer-main{
              transition: all 0.3s;
              background: rgba(0,0,0,0.7)
            }
        }
    }
    .ploar-footer-main {
        width: 100%;
        // height: 287px;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1000;
    }
    .ploar-footer-main-title {
        font-size: 18px;
        color: #e6e6e6;
        font-weight: 400;
        margin: 15px;
        margin-bottom: 0;
        margin-bottom: 10px;
        line-height: 1;
    }
    .ploar-footer-main-time {
        color: #d1d1d1;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        font-size: 14px;
        svg {
            font-size: 17px;
            margin: 0 5px 0 15px;
        }
    }
    .ploar-list-tag{
        position: absolute;
        top: 0;
        left: 0;
        padding-bottom: 10px;
        background: rgba(0, 0, 0, 0.2);
        z-index: 1000;
        display: flex;
        p {
            font-size: 14px;
            color: #fff;
            font-weight: 400;
            padding: 0px 13px;
            line-height: 1;
            margin-top: 10px;
            border-right: 1px solid #fff;
            &:last-child {
                border: none;
            }
        }
    }
    .ploar-trangle {
        width: 38px;
        height: 14px;
        position: absolute;
        top: 20px;
        right: 18px;
        z-index: 1000;
        img {
            width: 38px;
            height: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/polar.vue